import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/home/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  // 关于我们
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about/index.vue')
  },
  // 仪器租赁
  {
    path: '/yqzl',
    name: 'yqzl',
    component: () => import('@/views/lease/yqzl.vue')
  },
  // 以租代买
  {
    path: '/yzdm',
    name: 'yzdm',
    component: () => import('@/views/lease/yzdm.vue')
  },
  // 维修
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('@/views/maintenance/index.vue')
  },
  // 产品
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/product/index.vue')
  },
  // 产品详情
  {
    path: '/productDetails',
    name: 'productDetails',
    component: () => import('@/views/product/product-details.vue')
  },
  // 联系我们
  {
    path: '/relate',
    name: 'relate',
    component: () => import('@/views/relate/index.vue')
  },
  // 咨询报价
  {
    path: '/consultingService',
    name: 'consultingService',
    component: () => import('@/views/consultingService/index.vue')
  },
  // 技术服务
  {
    path: '/jsfw',
    name: 'jsfw',
    component: () => import('@/views/jsfw/index.vue')
  },
  // 仪器回收
  {
    path: '/yqhs',
    name: 'yqhs',
    component: () => import('@/views/yqhs/index.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 };
  }
})

export default router
